import { StateStatus } from '../../../../shared/infrastructure/store/utils/state_status';
import BankAccount from '../../domain/entities/bank_accounts';

interface BankAccountProps {
    status?: StateStatus;
    bankAccounts?: BankAccount[];
    error?: string;
}

class BankAccountState {
    status: StateStatus;
    bankAccounts: BankAccount[];
    error: string;

    constructor(props: BankAccountProps) {
        const { status, bankAccounts, error } = props;

        this.status = status ?? StateStatus.initial;
        this.bankAccounts = bankAccounts ?? [];
        this.error = error ?? undefined;
    }

    copyWith(props: BankAccountProps) {
        const { status, bankAccounts, error } = props;

        return new BankAccountState({
            status: status ?? this.status,
            bankAccounts: bankAccounts ?? this.bankAccounts,
            error: error ?? this.error
        });
    }
}

export default BankAccountState;
